// src/pages/History/RenaissanceReformation/NorthernRenaissance.jsx
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Renaissance_&_Reformation_-_Northern_Renaissance.png';

export default function HistoryPageNorthernRenaissance() {
  return (
    <TopicPage
      topicKey="Northern Renaissance"
      title="History: Northern Renaissance"
      backgroundImage={bg}
      startRoute="/History-Northern-Renaissance-Go"
      scrollLabels={[
        "Printing Press and Literacy",
        "Christian Humanism",
        "Art in the North",
      ]}
      backRoute="/history-renaissance"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}
